import React from 'react'
import Image from 'gatsby-image'
import styled from '@emotion/styled'
import { Global, css } from "@emotion/core"

export const breakpoints = {
  s: 576,
  m: 768,
  l: 992,
  xl: 1200,
}

export const GlobalStyle = props => (
  <Global
    {...props}
    styles={css`
      html {
                        font-size: 65.5%;
                        box-sizing: border-box;
                    }
                    *, *:before, *:after {
                        box-sizing: inherit;
                    }
                    body {
                        font-size: 16px;
                        font-size: 1.8rem;
                        line-height: 1.5;
                        font-family: 'PT Sans', sans-serif; 
                    }
                    h1, h2, h3 {
                        margin: 0;
                        line-height: 1.5;
                    }
                    h1, h2 {
                        font-family: 'Rpboto', serif;
                    }
                    h1{
                        font-family: 'PT Sans', sans-serif;

                    }
                    ul {
                        list-style: none;
                        margin: 0;
                        padding: 0;
                    }

                    .navbar-color {
                        background-color: rgb(44,62,80) !important;
                        width: 100% !important;
                    }

                    .clearfix {
                        float: none;
                        clear: both;
                    }
    `}
  />
)

export const Img = styled(Image)`
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
`

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  margin-bottom: 80px;
`

export const TwoColumnGrid = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 2rem 1fr;
  grid-template-rows: 1auto;
  grid-template-areas: "left . right";

  @media (max-width: ${breakpoints.l}px){
    display: block;
    margin-right: 20px;
    margin-left: 20px;
  }
`

export const GridLeft = styled.div`
  margin-top: 80px;
  grid-area: left;
`

export const GridRight = styled.div`
  grid-area: right;
`

export const MainContent = styled.main`
  margin-top: 80px;
  margin-bottom: 40px;

  @media (max-width: ${breakpoints.l}px){
    margin-top: 40px;
    margin-bottom: 20px;
  }
`